<lvr-heading [showEditButton]="false">
	{{ 'assignment.details.end_qb_report' | transloco }}
	<div ngProjectAs="button-content">
		@if (report()?.isFinal) {
			<lvr-button
				variant="primary"
				[label]="'base.button.export' | transloco"
				[ariaLabel]="'base.button.export_pdf' | transloco"
				[loadingLabel]="'base.button.generating_pdf' | transloco"
				[loading]="isExporting()"
				[type]="'button'"
				(clicked)="export('AbschlussQB.pdf')"
				icon="ios_share"
			></lvr-button>
		}
	</div>
</lvr-heading>
<lvr-section>
	@if (renderContent()) {
		<lvr-html-editor
			(docChange)="docUpdated($event)"
			[html]="renderContent()"
			[readOnly]="(report()?.isFinal ?? false) || !canEditReport()"
		></lvr-html-editor>
	}
</lvr-section>

<lvr-section>
	@if (!report()?.isFinal) {
		<div
			[matTooltip]="!canEditReport() ? ('base.button.edit_disabled' | transloco) : ''"
			[matTooltipDisabled]="canEditReport()"
		>
			<lvr-default-actions
				[disableSave]="!updateHtmlContent() || !canEditReport()"
				(save)="save()"
				(cancelSave)="cancel()"
				[showLoading]="isLoadingForSaveEndQbReport()"
			></lvr-default-actions>
		</div>
	}
</lvr-section>
